import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';

interface fieldMappingConfigInfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class FieldMappingService {
private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(
       private http: HttpClient,
       private snackBar: MatSnackBar,
       private spinner: NgxUiLoaderService,
       private restAPI: RestApi
     ) { }

     retreiveMappingTypes(tenantId) {
      return this.http.get<fieldMappingConfigInfo>(this.restAPI.RETRIEVE_MAPPING_TYPES+"/"+tenantId, { headers: this.headers })
    }

    retreiveFieldMapping(mappingTypeId) {
      return this.http.get<fieldMappingConfigInfo>(this.restAPI.RETRIEVE_FIELD_MAPPING_BY_MAPPINGTYPE+"/"+mappingTypeId, { headers: this.headers })
    }
    // 

    createFieldMapping(mappingDetails) {
      return this.http.post<fieldMappingConfigInfo>(this.restAPI.CREATE_FIELD_MAPPING_BY_MAPPINGTYPE,JSON.stringify(mappingDetails), { headers: this.headers })
    }
} 

